
export enum FeedbackQuestionType {
    CHOICE = "choice",
    MULTICHOICE = "multichoice",
    STRING = "string"
}